<template>
  <div id="about" class="about">
    <img width="120px" :src="require('@/assets/images/logo_sas_portrait.svg')"/>
    <p>Obrigado por usar nosso aplicativo.</p>
    <hr />
    <p>V0.7.0</p>
  </div>
</template>

<script>
export default {
  name: 'About',
  beforeCreate() {
    this.$store.commit('headerModeApp', 'Sobre');
  },
};
</script>

<style scoped>
  .about{
    width: 100%;
  }
  img {
    margin-bottom: 15px;
  }
  h2 {
    padding: 10px 0;
  }
</style>
